const env = import.meta.env;

/** Modalità demo: dati finti in memoria, nessun login. Mai in produzione. */
export const DEMO = __DEMO__;

function required(name: keyof ImportMetaEnv): string {
  const v = env[name];
  if (!v && !DEMO) throw new Error(`Variabile di configurazione mancante: ${name}`);
  return v ?? "";
}

const demoSite = "https://demo.sharepoint.com/sites/Portale3";

export const config = {
  clientId: required("VITE_ENTRA_CLIENT_ID"),
  tenantId: required("VITE_ENTRA_TENANT_ID"),
  graphScopes: (
    env.VITE_GRAPH_SCOPES ??
    "https://graph.microsoft.com/User.Read,https://graph.microsoft.com/Sites.ReadWrite.All,https://graph.microsoft.com/GroupMember.Read.All"
  )
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean),
  apiBaseUrl: env.VITE_API_BASE_URL?.replace(/\/$/, "") || undefined,
  apiScope: env.VITE_API_SCOPE || undefined,
  siteUrl: env.VITE_SITE_URL || (DEMO ? demoSite : undefined),
  devSiteUrl: env.VITE_DEV_SITE_URL || undefined,
  groups: {
    gestori: env.VITE_GROUP_GESTORI_ID || (DEMO ? "demo-gestori" : undefined),
    collaboratori: env.VITE_GROUP_COLLABORATORI_ID || (DEMO ? "demo-collaboratori" : undefined),
    lettori: env.VITE_GROUP_LETTORI_ID || (DEMO ? "demo-lettori" : undefined),
  },
  /** Cartella modello: se ne copiano le sottocartelle in ogni cartella di gara. */
  modelloUrl: env.VITE_MODELLO_URL || (DEMO ? `${demoSite}/Modelli/CartellaGara` : required("VITE_MODELLO_URL")),
  /** Logo della schermata di benvenuto (es. "/logo.png" in apps/web/public); vuoto = nessun logo. */
  logoUrl: env.VITE_LOGO_URL || undefined,
  /** Numero = ID dell'elemento + base (999 → la prima gara è OA1000). */
  numeroBase: Number(env.VITE_NUMERO_BASE ?? 999),
} as const;
